import React from 'react'

const Container: React.FC<{}> = ({ children }) => {
  return (
    <div className="rounded bg-white p-6 space-y-6 shadow-sm">{children}</div>
  )
}

export default Container
